jQuery(function () {
    jQuery('.video-accordion__link-title').attr("aria-expanded", "false");
    jQuery('.video-accordion__link-title--active').attr("aria-expanded", "true");

    jQuery('body').on('click', '.video-accordion__link-title', function (e) {
        var $this = jQuery(this);

        if ($this.hasClass('video-accordion__link-title--active')) {
            $this.attr("aria-expanded", "true");

        } else {
            $this.attr("aria-expanded", "false");
        }

        e.preventDefault();

        return false;
    });
});
